import { getSocket } from '@src/App';

export default async ({
  name,
  avatarKey,
}: { name: string; avatarKey: string }) => {
  try {
    getSocket().emit('profileUpdate', { username: name, avatar: avatarKey });
  } catch (e) {
    console.log(e);
  }
};
